<template>
  <v-container grid-list-md fluid class="pt-0 pb-3">
    <v-card class="pa-2 card-r grey lighten-4">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <v-btn icon to="/packages">
          <v-icon color="white">keyboard_arrow_left</v-icon>
        </v-btn>
        <div class="text-xs-left f-20">{{adminpackages.name}}</div>
        <v-spacer></v-spacer>
        <!-- <v-btn class="white shadow-1 mr-3 card-r" icon><v-icon class="textColor" @click="deleted = true">delete</v-icon></v-btn> -->
      </v-toolbar>
      <v-layout row wrap class="mt-2 card-r pr-2 pl-1">
        <v-flex lg5 xs12 class="text-xs-right right">
          <v-carousel  height="300"
                       class="no-shadow card-r white shadow-1 pa-3">
            <v-carousel-item
              v-for="(item,i) in adminpackages.image"
              :key="i"
              :src="adminpackages.image"
            ></v-carousel-item>
            <!-- {{adminpackage.name}} -->
          </v-carousel>
        </v-flex>
        <v-flex lg7 xs12 offset-xs0 class="white card-r shadow-1 mt-1 mb-1">
          <v-flex xs12 offset-xs0 class="ml-3 mr-3">
            <h1 class="mt-2">{{adminpackages.name}}</h1>
          </v-flex>
          <v-layout xs12>
            <v-flex xs12 offset-xs0 class="ml-3 mr-3">
              <span class="f-15 font-weight-bold text--darken-1 ">Price : - </span>
              <span class="f-15 font-weight-bold text--darken-1 ">$ {{adminpackages.cost}}</span>
            </v-flex>
          </v-layout>
          <!-- <v-layout xs12>
            <v-flex xs12 offset-xs0 class="text-xs-left ml-3">
              <span class="f-15 font-weight-bold text--darken-1">Hours : - </span>
              <span class="f-15 font-weight-bold text--darken-1">{{adminpackages.hours}} h</span>
            </v-flex>
          </v-layout> -->
          <v-layout xs12 class="ml-3 mr-3 mt-2">
            <v-flex xs12 >
              <p>{{adminpackages.description}}</p>

            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-container class="pa-0 mt-3">
        <v-layout wrap>
          <v-flex xs12 lg3 class="pa-2" v-for="(n, index) in adminpackages.modules" v-bind:key="index">
            <v-card class="shadow-1 card-r" >
              <!-- <a v-bind:to="'/viewclass/'+n.id"> -->
                <v-img v-bind:src="n.image" height="200px" class="card-r"></v-img>
              <!-- </a> -->
              <v-card-title primary-title>
                <div>
                  <div class="headline" style="color: #424242;">{{n.name}}</div>
                  <span class="grey--text">subtitle for class</span>
                </div>
              </v-card-title>

              <v-card-actions>
                <!--  <v-btn flat color="grey" to="/createclass"><v-icon class="px-2">edit</v-icon>Edit</v-btn>
                  <v-btn flat color="grey" v-bind:to="'/confirmdelete/'+n.id"><v-icon >delete</v-icon>delete</v-btn>-->

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-dialog v-model="deleted" max-width="290">
        <v-card class="card-r">
          <v-card-title class="f-17 text-capitalize">Are You Sure Want To Delete <span class="font-weight-bold f-17">Package</span>?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="grey text-white left card-r" text @click="deleted = false">No</v-btn>
            <v-btn class="primary text-white card-r" text @click="deleted = false">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-card>
    </v-container>
</template>
<style>
.v-carousel__next .v-btn i, .v-carousel__prev .v-btn i{
  font-size: 45px !important;
}
.v-carousel__controls{
  display: none!important;
}
</style>
<script>
/* eslint-disable */
// import ConfirmSignup from "../auth/ConfirmSignup";
  import { mapState, dispatch } from "vuex";
  export default {
    name: 'Viewpackage',
    data () {
      return {
        deleted: false,
        items: [
          {
            src: 'https://irp-cdn.multiscreensite.com/f6d3566d/dms3rep/multi/mobile/iStock-540862480-2121x1414.jpg'
          },
          {
            src: 'https://www.mercedesbenzdrivingacademy.ca/wp-content/uploads/2017/04/mercedes-benz-driver-training-education.jpg'
          },
          {
            src: 'https://i.ytimg.com/vi/Vxekzd2lcfg/maxresdefault.jpg'
          },
          {
            src: 'https://d3lp4xedbqa8a5.cloudfront.net/imagegen/max/ccr/1023/-/s3/digital-cougar-assets/whichcar/2015/11/27' +
            '/-1/Volvo-V40-driving-course.jpg'
          },
          {
            src: 'https://i.ytimg.com/vi/asy1qhZ9Dck/maxresdefault.jpg'
          }
        ],
        attachment: {
        photos: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      PackageTitle:'',
      PackagePrice:'',
      InternalPrice:'',
      Description:'',
      selectedClasses:'',
      module_id:[],
      }
    },
        props:['id'],
     created() {
      this.packageId = this.$route.params.id;
      Store.dispatch("Packages/getPackageById", this.packageId).then(res => {
      });
  },
  computed: {
    ...mapState({
      adminpackages: Packages => Store.state.Packages.adminpackages
    })
  },
  }
</script>



// WEBPACK FOOTER //
// src/components/package/ViewPackage.vue